import { GameObj } from "../GameObj";
import { getFactionName } from "../types";
import { UnitType } from "./UnitType";
import type { UnitContext, ObjContext, MakeContext } from "./context";

export class Seat extends UnitType {
    readonly id = "seat";
    readonly displayName = "Seat";
    name(ctx: UnitContext) { return "The seat of " + getFactionName(ctx.faction); }
    description(ctx: UnitContext) {
        return "Produces blood per Influence. (" + this.bloodProduced(ctx) + ")\n"
            + ctx.game.factionData[ctx.faction].souls + " souls   "
            + ctx.game.factionData[ctx.faction].blood + " blood   "
            + ctx.game.factionData[ctx.faction].runes + " runes";
    }
    img(ctx: UnitContext) { return "seat_" + ctx.faction; }
    maxCooldown() { return 2000; }
    make(ctx: MakeContext) { return new GameObj(ctx.faction, "seat"); }
    aiAlwaysSteps(): boolean { return true; }
    step(ctx: ObjContext) {
        if (!ctx.obj || !ctx.obj.isReady(this.maxCooldown())) return;
        ctx.obj.setNotReady();
        ctx.game.addResource(ctx.obj.faction, "blood", this.bloodProduced(ctx));
    }
    influenceRange(): number { return 3.5; }


    private bloodProduced(ctx: UnitContext): number {
        const count = ctx.game.influenceMap.getInfluenceCount(ctx.faction);
        return 1 + Math.floor(count / 100.0);
    }
}
